import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=f0a3b26c&scoped=true&lang=pug&"
import script from "./ProductWindow.vue?vue&type=script&lang=ts&"
export * from "./ProductWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=f0a3b26c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a3b26c",
  null
  
)

export default component.exports